import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function getMpkEvent(
  eventId: string
): Promise<AxiosResponse<{ [key: string]: string }>> {
  return instance.get(`/mpk/event?eventId=${eventId}`)
}
